import {types} from "mobx-state-tree"


const FilterBase = types
  .model({id:types.string})
  
  .volatile(self => ({
    value: {},
    default_value: {},
    label:''
  }))
  .actions(self => ({

    //Set specific filter
    setValue(value) {
      self.value = value
    },

    setLabel(label) {
      self.label = label
    },

    setDefaultValue(value) {
      self.default_value= Object.freeze(value)
    },

    reset_value(){
      self.value= {}
    },

    is_dirty(){
      return (self.value !== self.default_value)
    }
  }))

export default FilterBase